<template>
  <div>
    <el-drawer v-loading="loading" title="委外加工单" :visible.sync="show" size="90%" :before-close="handleClose" destroy-on-close center :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="130px">
        <el-card header="基础信息">
          <el-row>
            <el-col :span="6">
              <el-form-item label="委外申请单号">
                <el-input v-model="form.sn" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="单据类型" prop="orderType">
                <el-select v-model="form.orderType" :disabled="type == '查看'|| isDisabled || isRejectTo" placeholder="请选择" @change="changeOrderType">
                  <el-option v-for="item in orderTypeOptions" :key="item.code" :label="item.name" :value="item.code" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="委外加工供应商" prop="supplierId">
                <el-select v-model="form.supplierId" :disabled="type == '查看' || isDisabled || isRejectTo">
                  <el-option v-for="item in supplierOptions" :key="item.value" :label="item.label" :value="item.value" />
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="订单状态" prop="status">
                <el-input v-model="statusArr[form.status]" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="创建人">
                <el-input v-model="form.createUser" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="10">
              <el-form-item label="创建时间">
                <el-input v-model="form.createTime" :disabled="true" placeholder="自动生成" />
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="铂总量">
                <el-input v-model="form.platinumTotal" :disabled="!(form.status==3&&form.gargoLoadingStatus==3)" type="number">
                  <template slot="append">g</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="钯总量">
                <el-input v-model="form.palladiumTotal" :disabled="!(form.status==3&&form.gargoLoadingStatus==3)" type="number">
                  <template slot="append">g</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="5">
              <el-form-item label="铑总量">
                <el-input v-model="form.rhodiumTotal" :disabled="!(form.status==3&&form.gargoLoadingStatus==3)" type="number">
                  <template slot="append">g</template>
                </el-input>
              </el-form-item>
            </el-col>
            <el-col v-if="[3].includes(form.status)" :span="8">
              <el-form-item label="加工费用">
                <el-input v-model="form.processAmount" :disabled="form.gargoLoadingStatus==5" style="width: 70%" type="number" placeholder="请输入加工费" />
                <el-button v-if="(form.processAmount && form.gargoLoadingStatus!=5) || (form.status==3&&form.gargoLoadingStatus==3)" style="margin-left: 10px;" type="primary" @click="expenseConfirm()">保存</el-button>

              </el-form-item>
            </el-col>
          </el-row>
        </el-card>
        <!-- <el-card header="附件信息">
          <el-row>
            <FileUpload :file-type="['png', 'jpg', 'jpeg','doc','xls','pdf','xlsx','docx']" :value.sync="form.crmSalesIndeterminateAccessoryModels" :show-delect="form.status <= 1 || form.status==null" />
          </el-row>
        </el-card> -->
        <el-card header="">
          <el-tabs v-model="activePaneName">
            <el-tab-pane label="订单明细" name="mountings">
              <div style="display: flex;justify-content: flex-end;align-items: center;margin-bottom: 10px ;">
                <div v-if="[3].includes(form.status)&&isExpense" class="btn" @click="addPurchase()">录入采购订单</div>
                <div v-if="[2,3,4,5].includes(form.gargoLoadingStatus)" class="btn" @click="addFinishedProduct()">录入加工成品</div>
                <el-button type="primary" :disabled="type == '查看' || isRejectTo" @click="addOutsourceLineModels()">新增一行</el-button>
                <el-button type="danger" :disabled="type == '查看' || isRejectTo" @click="delectOutsourceLineModels()">一键清空列表</el-button>
                <excel-import v-if="form.orderType === 2 || form.orderType === '2'" :is-download-template="false" template-name="CrmOutsourceProcessingLineDataImport.xlsx" url="/crm/outsource/line/excelImport" template="CrmOutsourceProcessingLineDataImport.xlsx" class-name="CrmOutsourceProcessingLineDataImport" title="导入" @resdata="getOutsourceProcessingLine" />
                <el-button v-if="form.orderType === 2 || form.orderType === '2'" type="primary" style="margin-left: 5px;" @click="handleOutsourceProcessingDownload()">下载模版</el-button>
              </div>
              <el-table ref="mountingsTable" :data="form.crmOutsourceProcessingLineModels" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div>{{ scope.row.productCode }}</div>
                    <!-- <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item> -->
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div>{{ scope.row.productName }}</div>
                    <!-- <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item> -->
                  </template>
                </el-table-column>
                <el-table-column label="订单数量" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div v-if="type == '查看' || isRejectTo">{{ scope.row.qty }}</div>
                    <el-form-item v-else :prop="
                        'crmOutsourceProcessingLineModels.' + scope.$index + '.qty'
                      " :rules="crmOutsourceProcessingLineModels.qty">
                      <el-input v-model.number="scope.row.qty" type="number" :disabled="type == '查看' || isRejectTo" placeholder="请填写" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次" align="left" width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div>{{ scope.row.batch }}</div>
                    <!-- <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item> -->
                  </template>
                </el-table-column>
                <el-table-column label="产值" align="left" width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div>{{ scope.row.twcOutput }}</div>
                    <!-- <el-form-item prop="twcOutput">
                      <el-input v-model="scope.row.twcOutput" :disabled="true" placeholder="自动生成" />
                    </el-form-item> -->
                  </template>
                </el-table-column>
                <el-table-column label="单位" align="left" width="100" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <div>{{ scope.row.unit }}</div>
                    <!-- <el-form-item prop="unit">
                      <el-input v-model="scope.row.unit" :disabled="true" placeholder="自动生成" />
                    </el-form-item> -->
                  </template>
                </el-table-column>
                <!-- <el-table-column label="委外加工单价（元/KG）" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'crmOutsourceProcessingLineModels.' + scope.$index + '.price'
                      " :rules="crmOutsourceProcessingLineModels.price">
                      <el-input v-model.number="scope.row.price" :disabled="type == '查看' || isRejectTo" type="number" placeholder="请填写" />
                    </el-form-item>
                  </template>
                </el-table-column> -->
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" :disabled="type == '查看' || isRejectTo" @click="handleMountingsDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="实验室投入" :disabled="!(form.orderType === 2 || form.orderType === '2')" name="flotsam">
              <div style="display: flex;justify-content: flex-end;align-items: center;margin-bottom: 10px ;">
                <el-button type="primary" :disabled="type == '查看' || isRejectTo" @click="addOutsourceInputModels()">新增一行</el-button>
                <el-button type="danger" :disabled="type == '查看' || isRejectTo" @click="delectOutsourceInputModels()">一键清空列表</el-button>
                <excel-import v-if="form.orderType === 2 || form.orderType === '2'" :is-download-template="false" template-name="CrmOutsourceProcessingInputDataImport.xlsx" url="/crm/outsource/input/excelImport" template="CrmOutsourceProcessingInputDataImport.xlsx" class-name="CrmOutsourceProcessingInputDataImport" title="导入" @resdata="getOutsourceProcessingInput" />
                <el-button v-if="form.orderType === 2 || form.orderType === '2'" type="primary" style="margin-left: 5px;" @click="handleOutsourceProcessingInputDownload()">下载模版</el-button>
              </div>
              <el-table ref="mountingsInputTable" :data="form.crmoutsourceprocessinginputmodels" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'crmoutsourceprocessinginputmodels.' + scope.$index + '.qty'
                      " :rules="crmoutsourceprocessinginputmodels.qty">
                      <el-input v-model.number="scope.row.qty" type="number" :disabled="type == '查看' || isRejectTo" placeholder="请填写" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次" align="left" width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="产值" align="left" width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="twcOutput">
                      <el-input v-model="scope.row.twcOutput" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" :disabled="type == '查看' || isRejectTo" @click="handleMountingsInputDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
            <el-tab-pane label="实验室产出" :disabled="!(form.orderType === 2 || form.orderType === '2')" name="spareParts">
              <div style="display: flex;justify-content: flex-end;align-items: center;margin-bottom: 10px ;">
                <el-button type="primary" :disabled="type == '查看' || isRejectTo" @click="addOutsourceOutputModels()">新增一行</el-button>
                <el-button type="danger" :disabled="type == '查看' || isRejectTo" @click="delectOutsourceOutputModels()">一键清空列表</el-button>
              </div>
              <el-table ref="flotsamOutputTable" :data="form.crmoutsourceprocessingoutputmodels" border>
                <el-table-column type="index" label="序号" width="50" />
                <el-table-column label="物料编码" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="productCode">
                      <el-input v-model="scope.row.productCode" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料名称" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="productName">
                      <el-input v-model="scope.row.productName" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="数量" align="left" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item :prop="
                        'crmOutsourceProcessingLineModels.' + scope.$index + '.qty'
                      " :rules="crmOutsourceProcessingLineModels.qty">
                      <el-input v-model.number="scope.row.qty" type="number" :disabled="type == '查看' || isRejectTo" placeholder="请填写" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="批次" align="left" width="150" show-overflow-tooltip>
                  <template slot-scope="scope">
                    <el-form-item prop="batch">
                      <el-input v-model="scope.row.batch" :disabled="true" placeholder="自动生成" />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="操作" fixed="right" width="100">
                  <template slot-scope="scope">
                    <el-button type="text" :disabled="type == '查看' || isRejectTo" @click="handleMountingsOutputDelete(scope.$index)">删除</el-button>
                  </template>
                </el-table-column>
              </el-table>
            </el-tab-pane>
          </el-tabs>
        </el-card>
        <el-card header="流程审批">
          <div v-if="form.status <= 1 || form.status==null">
            <el-row>
              <el-col :span="8">
                <el-form-item label="选择流程模板" prop="flowPathTemplateId">
                  <el-select v-model="form.flowPathTemplateId" placeholder="选择模板" @change="getFlowTempInfoList">
                    <el-option v-for="item in flowPathOptions" :key="item.id" :label="item.templateName" :value="item.id" />
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-table v-if="form.flowPathNodePersonModels && form.flowPathNodePersonModels.length>0" ref="elTable" style="width:50%" :data="form.flowPathNodePersonModels" border>
              <el-table-column label="节点名称" align="left" show-overflow-tooltip width="150">
                <template slot-scope="scope">
                  <el-form-item prop="nodePersonName">
                    {{ scope.row.nodePersonName }}
                  </el-form-item>
                </template>
              </el-table-column>
              <el-table-column label="审批人" align="left" show-overflow-tooltip width="auto">
                <template slot-scope="scope">
                  <el-form-item :prop="
                      'flowPathNodePersonModels.' + scope.$index + '.nodePerson'
                    " :rules="flowPathNodePersonModels.nodePerson">
                    <el-input v-model="scope.row.nodePerson" readonly placeholder="请点击图标选择">
                      <el-button v-if="scope.row.variable" slot="append" icon="el-icon-search" @click="selectNodePerson(scope.$index)" />
                    </el-input>
                  </el-form-item>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <Flow ref="flow" :disabled="type == '查看' || form.status > 2" :custom-event="true" :flow-id="form.flowId" @flowLoad="flowLoad" @complete="onComplete" @refresh="flowRefresh" @rejectTo="flowRejectTo" />
        </el-card>
        <el-row style="padding: 10px 20px">
          <el-button :disabled="[3].includes(form.status)" :loading="loading" type="primary" @click="submitForm('form',false)">保存</el-button>
          <el-button v-if="form.id && (form.status == 1 || !form.status)" type="primary" @click="saveAndSubmit()">提交</el-button>
          <el-button @click="handleClose">取消</el-button>
        </el-row>
      </el-form>
    </el-drawer>
    <!-- 选择审批人 -->
    <el-dialog class="dialog" :title="'选择审批人'" :visible.sync="showObj.nodePerson" width="30%" :before-close="nodePersonClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.nodePerson.nodePerson" clearable placeholder="请输入审批人名称" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getNodePersonDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.nodePerson" border height="300" @selection-change="handleNodePersonSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="审批人" align="left" prop="nodePerson" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.nodePerson.total" :page.sync="pagination.nodePerson.current" :limit.sync="pagination.nodePerson.size" @pagination="getNodePersonDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nodePersonClose">取消</el-button>
        <el-button type="primary" @click="nodePersonConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品配料 -->
    <el-dialog class="dialog" title="产品配料" :visible.sync="showObj.mountings" width="70%" :before-close="mountingsClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.oeCode" clearable placeholder="请输入OE" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.mountings.carNo" clearable placeholder="请输入车牌" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getMountings('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.mountings" :data="dialog.mountings" border height="300" @selection-change="handleMountingsChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" width="150" prop="productCode" show-overflow-tooltip />
        <el-table-column label="OE" align="left" width="150" prop="oeCode" show-overflow-tooltip />
        <el-table-column label="批次号" align="left" width="150" prop="batch" show-overflow-tooltip />
        <el-table-column label="车辆ID" align="left" width="150" prop="carId" show-overflow-tooltip />
        <el-table-column label="产值" align="left" width="150" prop="twcOutput" show-overflow-tooltip />
        <el-table-column label="车牌" align="left" width="150" prop="carNo" show-overflow-tooltip />
        <el-table-column label="品牌" align="left" prop="brand" show-overflow-tooltip />
        <el-table-column label="车系" align="left" prop="series" show-overflow-tooltip />
        <el-table-column label="年款" align="left" prop="modelYear" show-overflow-tooltip />
        <el-table-column label="发动机型号" align="left" prop="engineModel" show-overflow-tooltip />
        <el-table-column label="变速箱型号" align="left" prop="transmissionModel" show-overflow-tooltip />
        <el-table-column label="排量" align="left" prop="displacement" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.mountings.total" :page.sync="pagination.mountings.current" :limit.sync="pagination.mountings.size" @pagination="getMountings" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="mountingsClose">取消</el-button>
        <el-button type="primary" @click="mountingsConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 产品废料 -->
    <el-dialog class="dialog" title="产品废料" :visible.sync="showObj.flotsam" width="60%" :before-close="flotsamClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.flotsam.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getFlotsam('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.flotsam" :data="dialog.flotsam" border height="300" @selection-change="handleFlotsamChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />

      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.flotsam.total" :page.sync="pagination.flotsam.current" :limit.sync="pagination.flotsam.size" @pagination="getFlotsam" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="flotsamClose">取消</el-button>
        <el-button type="primary" @click="flotsamConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 录入加工成品 -->
    <el-dialog class="dialog" title="录入加工成品" :visible.sync="showObj.finished" width="80%" :before-close="finishedClose" destroy-on-close center :close-on-click-modal="false">
      <div style="display: flex;justify-content: flex-end;align-items: center;margin-bottom: 10px ;">
        <el-button v-if="form.gargoLoadingStatus!=5" type="primary" @click="addOutsourceFlotsamLine()">新增明细</el-button>
      </div>
      <el-table ref="listTable" v-loading="loadingObj.finished" :data="dialog.finished" border height="300">
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="加工后成品" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="加工后成品编码" align="left" prop="productCode" show-overflow-tooltip />
        <el-table-column label="重量（KG）" align="left" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-input v-model.number="scope.row.weight" :disabled="form.gargoLoadingStatus==5" type="number" placeholder="请填写" />
          </template>
        </el-table-column>
        <el-table-column v-if="form.gargoLoadingStatus!=5" label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <el-button type="text" @click="handleFinishedDelete(scope.row.id)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.finished.total" :page.sync="pagination.finished.current" :limit.sync="pagination.finished.size" @pagination="getFinished" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="finishedClose">关闭</el-button>
        <el-button v-if="form.gargoLoadingStatus!=5" type="primary" @click="finishedConfirm()">保存</el-button>
      </span>
    </el-dialog>
    <!-- 加工产出废料 -->
    <el-dialog class="dialog" title="加工产出废料" :visible.sync="showObj.outsourceFlotsam" width="60%" :before-close="outsourceFlotsamClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="6">
          <el-input v-model="condition.outsourceFlotsam.productName" clearable placeholder="请输入物料名称" />
        </el-col>
        <el-col :span="6">
          <el-input v-model="condition.outsourceFlotsam.productCode" clearable placeholder="请输入产品编码" />
        </el-col>
        <el-col :span="6">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getOutsourceFlotsam('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loadingObj.outsourceFlotsam" :data="dialog.outsourceFlotsam" border height="300" @selection-change="handleOutsourceFlotsamChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="物料名称" align="left" prop="productName" show-overflow-tooltip />
        <el-table-column label="产品编码" align="left" prop="productCode" show-overflow-tooltip />
      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.outsourceFlotsam.total" :page.sync="pagination.outsourceFlotsam.current" :limit.sync="pagination.outsourceFlotsam.size" @pagination="getOutsourceFlotsam" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="outsourceFlotsamClose">取消</el-button>
        <el-button type="primary" @click="outsourceFlotsamConfirm">确认</el-button>
      </span>
    </el-dialog>
    <!-- 配件-采购订单 -->
    <el-dialog class="dialog" title="采购订单信息" :visible.sync="showObj.purchase" width="50%" :before-close="purchaseClose" destroy-on-close center>
      <el-form ref="purchaseForm" :model="purchaseRow" :rules="purchaseRules" label-width="120px">
        <el-form-item label="采购订单号" prop="poNo">
          <el-input v-model="purchaseRow.poNo" :disabled="true" placeholder="自动生成" />
        </el-form-item>
        <el-form-item label="sap采购订单号" prop="sapPoNo">
          <el-input v-model="purchaseRow.sapPoNo" :disabled="true" placeholder="自动生成" />
        </el-form-item>
        <el-form-item label="交货工厂" prop="factoryId">
          <el-select v-model="purchaseRow.factoryId" placeholder="请选择" :disabled="true">
            <el-option v-for="item in factoryOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="存储地点" prop="warehouseCode">
          <el-input v-model="purchaseRow.warehouseCode" readonly placeholder="请点击图标选择">
            <el-button slot="append" icon="el-icon-search" :disabled="form.gargoLoadingStatus==5" @click="selectWarehouse()" />
          </el-input>
        </el-form-item>
        <el-form-item label="供应商" prop="supplierId">
          <el-select v-model="purchaseRow.supplierId" :disabled="form.gargoLoadingStatus==5">
            <el-option v-for="item in supplierOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="采购组织" prop="purchasingOrganizationId">
          <el-select v-model="purchaseRow.purchasingOrganizationId" :disabled="form.gargoLoadingStatus==5">
            <el-option v-for="item in purchasingOrganizationOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="采购组" prop="purchaseBasicsId">
          <el-select v-model="purchaseRow.purchaseBasicsId" :disabled="form.gargoLoadingStatus==5">
            <el-option v-for="item in purchaseBasicsOptions" :key="item.value" :label="item.label" :value="item.value" />
          </el-select>
        </el-form-item>
        <el-form-item label="单价" prop="unitPrice">
          <el-input v-model="purchaseRow.unitPrice" type="number" :disabled="form.gargoLoadingStatus==5" placeholder="请输入单价" clearable />
        </el-form-item>
        <el-form-item label="总金额" prop="sumPrice">
          <el-input v-model="purchaseRow.sumPrice" type="number" :disabled="form.gargoLoadingStatus==5" placeholder="请输入总金额" clearable />
        </el-form-item>
        <el-form-item label="进项税" prop="taxCode">
          <el-select v-model="purchaseRow.taxCode" :disabled="form.gargoLoadingStatus==5">
            <el-option v-for="item in inputTaxOptions" :key="item.code" :label="item.name +'-'+item.code" :value="item.name" />
          </el-select>
        </el-form-item>
        <el-form-item label="备注" prop="remark">
          <el-input v-model="purchaseRow.remark" :disabled="form.gargoLoadingStatus==5" placeholder="请输入备注" clearable />
        </el-form-item>
        <el-form-item>
          <el-button v-if="form.gargoLoadingStatus!=5" type="primary" @click="purchaseConfirm">确认</el-button>
          <el-button @click="purchaseClose">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <!-- 存储地点 -->
    <el-dialog class="dialog" :title="'选择存储地点'" :visible.sync="showObj.warehouse" width="60%" :before-close="warehouseClose" destroy-on-close center :close-on-click-modal="false">
      <el-row>
        <el-col :span="8">
          <el-input v-model="condition.warehouse.warehouseNumber" clearable placeholder="请输入存储代码" />
        </el-col>
        <el-col :span="8">
          <el-button style="margin-left: 10px;" type="primary" icon="el-icon-search" @click="getWarehouseDialog('refresh')">查询</el-button>
        </el-col>
      </el-row>
      <el-table ref="listTable" v-loading="loading" :data="dialog.warehouse" border height="300" @selection-change="handleWarehouseSelectionChange">
        <el-table-column type="selection" width="55" />
        <el-table-column type="index" label="序号" width="50" />
        <el-table-column label="存储代码" align="left" prop="warehouseNumber" show-overflow-tooltip />
        <el-table-column label="存储描述" align="left" prop="warehouseName" show-overflow-tooltip />

      </el-table>
      <el-row class="footer-box">
        <pagination :total="pagination.warehouse.total" :page.sync="pagination.warehouse.current" :limit.sync="pagination.warehouse.size" @pagination="getWarehouseDialog" />
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button @click="warehouseClose">取消</el-button>
        <el-button type="primary" @click="warehouseConfirm">确认</el-button>
      </span>
    </el-dialog>
  </div>

</template>

<script>
import Pagination from '@/components/Pagination'
import Flow from '@/components/Flow'
import format from '@/utils/formatter'
import { getEnumItems } from '@/utils/enum'
import { getByPathTemplate, getFlowTempInfo } from '@/api/flow/processConfiguration'
import {
  get,
  saveOrUpdate,
  submit,
  getFinished,
  saveOrUpdateFinished,
  deleteByIdFinished,
  getPurchase,
  saveOrUpdateExpense,
  saveOrUpdatePurchase,
  downloadOutsourceProcessingTemplate,
  downloadOutsourceProcessingInputTemplate,
  downloadOutsourceProcessingOutputTemplate
} from '@/api/crm/outsource/workSheet'
import { getPage as getSupplierOptions } from '@/api/crm/base/supplier'
import { getByGeneralManager } from '@/api/crm/base/audit'
import { outsourcePagePopup as getMountingsApi } from '@/api/crm/product/fittings'
import { getPagePopup as getFlotsamApi } from '@/api/crm/product/scraps'
import { getPage as getPurchasingOrganization } from '@/api/crm/base/purchasingOrganization'
import { getPage as getPurchaseBasicsOptions } from '@/api/crm/base/purchase'
import { getPage as getFactory } from '@/api/crm/base/factory'
import { mergeObjectArrayWithoutDuplicates } from '@/utils/index'
import { getCompanyInfoFactoryListPage } from '@/api/crm/deliver/deliveryNote'
import ExcelImport from '@/components/ExcelImport'
import { downloadFile } from '@/utils/file'
export default {
  name: 'WorkSheetEdit',
  components: {
    Pagination,
    Flow,
    ExcelImport
  },
  filters: {
  },
  props: {
    show: {
      type: Boolean,
      default() {
        return false
      }
    },
    editId: Number
  },

  data() {
    return {
      flowPathOptions: [],
      format: format,
      type: '',
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL,
      loading: false,
      form: {
        crmOutsourceProcessingLineModels: [],
        crmoutsourceprocessinginputmodels: [],
        crmoutsourceprocessingoutputmodels: [],
        // 默认委外废料单
        orderType: '1'
      },
      statusArr: ['', '制单', '审核中', '审核完成'],
      flowPathNodePersonModels: {
        nodePerson: [
          { required: true, message: '审批人不能为空', trigger: 'change' }
        ]
      },
      crmOutsourceProcessingLineModels: {
        qty: [
          { required: true, message: '订单数量不能为空', trigger: 'blur' }
        ]
        // price: [
        //   { required: true, message: '委外加工单价不能为空', trigger: 'blur' }
        // ]
      },
      crmoutsourceprocessinginputmodels: {
        qty: [
          { required: true, message: '数量不能为空', trigger: 'blur' }
        ]
      },
      crmoutsourceprocessingoutputmodels: {
        qty: [
          { required: true, message: '数量不能为空', trigger: 'blur' }
        ]
      },
      rules: {
        supplierId: [
          { required: true, message: '委外加工供应商不能为空', trigger: 'change' }
        ],
        orderType: [
          { required: true, message: '单据类型不能为空', trigger: 'change' }
        ]
      },
      finishedRules: {
        weight: [
          { required: true, message: '重量（KG）不能为空', trigger: 'blur' }
        ]
      },
      orderTypeOptions: getEnumItems('OutsourcedProcessingDocumentType'),
      showObj: {
        mountings: false,
        flotsam: false,
        nodePerson: false,
        finished: false,
        outsourceFlotsam: false,
        purchase: false,
        warehouse: false,
        mountingsInput: false,
        flotsamOutput: false
      },
      loadingObj: {
        mountings: false,
        flotsam: false,
        nodePerson: false,
        finished: false,
        outsourceFlotsam: false,
        warehouse: false
      },
      activePaneName: 'mountings',
      // 分页
      pagination: {
        mountings: {
          total: 0,
          size: 20,
          current: 1
        },
        flotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        nodePerson: {
          total: 0,
          size: 20,
          current: 1
        },
        finished: {
          total: 0,
          size: 20,
          current: 1
        },
        outsourceFlotsam: {
          total: 0,
          size: 20,
          current: 1
        },
        warehouse: {
          total: 0,
          size: 20,
          current: 1
        }
      },
      dialog: {
        mountings: [],
        flotsam: [],
        nodePerson: [],
        finished: [],
        outsourceFlotsam: [],
        warehouse: []
      },
      condition: {
        mountings: {},
        flotsam: {},
        nodePerson: {},
        outsourceFlotsam: {},
        warehouse: {}
      },
      selection: {
        mountings: [],
        flotsam: [],
        nodePerson: [],
        outsourceFlotsam: [],
        warehouse: []
      },
      isDisabled: false,
      isRejectTo: false,
      supplierOptions: [],
      purchaseRow: {
        poNo: null,
        sapPoNo: null,
        supplierId: null,
        purchasingOrganizationId: null,
        purchaseBasicsId: null,
        unitPrice: 1,
        sumPrice: null,
        taxCode: null,
        remark: null,
        factoryId: null,
        warehouseId: null,
        warehouseCode: null
      },
      purchaseRules: {
        purchasingOrganizationId: [
          { required: true, message: '采购组织不能为空', trigger: 'change' }
        ],
        unitPrice: [
          { required: true, message: '单价不能为空', trigger: 'blur' }
        ],
        sumPrice: [
          { required: true, message: '总金额不能为空', trigger: 'blur' }
        ],
        taxCode: [
          { required: true, message: '进项税不能为空', trigger: 'change' }
        ],
        factoryId: [
          { required: true, message: '交货工厂不能为空', trigger: 'change' }
        ],
        warehouseCode: [
          { required: true, message: '存储地点不能为空', trigger: ['change', 'blur'] }
        ]
      },
      purchasingOrganizationOptions: [],
      purchaseBasicsOptions: [],
      inputTaxOptions: getEnumItems('InputTax'),
      isExpense: false,
      factoryOptions: []
      // { lordDutyPrice: null, taxRatio: null, taxlessPrice: null }
      // mountingsList: [],
      // flotsamList: []
    }
  },
  watch: {
    show(show) {
      if (!show) {
        return
      }
      this.init()
      if (this.editId == null) {
        this.form = this.$options.data.call(this).form
        return
      }
      this.getData()
    },
    'form.crmOutsourceProcessingLineModels': {
      handler(val) {
        this.judegIsDisabled()
      }
    }
  },
  methods: {
    init() {
      getSupplierOptions({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.supplierOptions = records.map((item) => {
          return {
            label: item.supplierNo + '-' + item.supplierName,
            value: item.id
          }
        })
      })
      getByPathTemplate({ templateType: '委外加工管理' }, { current: 1, size: 100 }).then((res) => {
        const { records } = res.data
        this.flowPathOptions = records
      })
      getPurchasingOrganization({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.purchasingOrganizationOptions = records.map((item) => {
          return {
            label: item.purchasingOrganizationNumber + '-' + item.purchasingOrganizationName,
            value: item.id
          }
        })
      })
      getPurchaseBasicsOptions({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.purchaseBasicsOptions = records.map((item) => {
          return {
            label: item.purchaseNo + '-' + item.purchaseName,
            value: item.id
          }
        })
      })
      getFactory({}, { current: 1, size: 1000 }).then((response) => {
        const { records } = response.data
        this.factoryOptions = records.map((item) => {
          return {
            label: item.factoryNumber + '-' + item.factoryName,
            value: item.id
          }
        })
      })
    },
    // 审批人
    async getNodePersonDialog() {
      this.loadingObj.nodePerson = true
      const reponse = await getByGeneralManager(this.condition.nodePerson.nodePerson, this.form.roleId, this.pagination.nodePerson)
      const { current, total, size, records } = reponse.data
      this.dialog.nodePerson = records
      this.pagination.nodePerson.total = total
      this.pagination.nodePerson.current = current
      this.pagination.nodePerson.size = size
      this.loadingObj.nodePerson = false
    },
    async getFlowTempInfoList(e) {
      this.loading = true
      this.form.flowPathNodePersonModels = []
      const i = this.flowPathOptions.findIndex(v => v.id === e)
      this.form.roleId = this.flowPathOptions[i].roleId
      try {
        const res = await getFlowTempInfo(this.flowPathOptions[i].templateName)
        const nodeList = res.data.nodeList
        nodeList.shift()
        for (const item of nodeList) {
          let nodeVariate = ''
          const arr = []
          for (const v of item.userList) {
            if (v.variable) {
              v.username = v.username.substring(2, 13)
            }
            arr.push(v.username)
          }
          nodeVariate = arr.join()

          // 指定审核人赋值
          let nodePerson = null
          if (!item.userList[0].variable) {
            nodePerson = nodeVariate
          } else {
            nodePerson = null
          }
          this.form.flowPathNodePersonModels.push({
            nodePersonName: item.name,
            nodeVariate,
            nodePerson,
            nodePersonId: null,
            variable: item.userList[0].variable
          })
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    changeOrderType() {
      this.form.crmOutsourceProcessingLineModels = []
    },
    handleNodePersonSelectionChange(val) {
      this.selection.nodePerson = val
    },
    selectNodePerson(index) {
      this.nodePersonIndex = index
      this.showObj.nodePerson = true
      this.getNodePersonDialog()
    },

    nodePersonConfirm() {
      if (this.selection.nodePerson.length > 1) {
        this.$message.warning('只能选择一位审批人！')
      } else {
        this.showObj.nodePerson = false
        console.log(this.selection.nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePerson', this.selection.nodePerson[0].nodePerson)
        this.$set(this.form.flowPathNodePersonModels[this.nodePersonIndex], 'nodePersonId', this.selection.nodePerson[0].nodePersonId)
      }
    },
    nodePersonClose() {
      this.showObj.nodePerson = false
    },
    addOutsourceLineModels() {
      this.showObj.mountingsInput = false
      this.showObj.flotsamOutput = false
      if (this.form.orderType === 1 || this.form.orderType === '1') {
        this.addFlotsamLine()
      } else if (this.form.orderType === 2 || this.form.orderType === '2') {
        this.addMountingsLine()
      } else {
        this.$message.warning('请先选择单据类型')
        return
      }
    },
    addOutsourceInputModels() {
      this.addMountingsInput()
    },
    addOutsourceOutputModels() {
      this.addMountingsOutput()
    },
    // 实验室投入配件
    addMountingsInput() {
      this.showObj.mountings = true
      this.showObj.mountingsInput = true
      this.getMountingInputs()
    },
    // 实验室产出废料
    addMountingsOutput() {
      this.showObj.flotsam = true
      this.showObj.flotsamOutput = true
      this.getFlotOutputsam()
    },
    async getMountingInputs(type = '') {
      if (type === 'refresh') {
        this.pagination.mountings.current = 1
      }
      this.loadingObj.mountings = true
      const reponse = await getMountingsApi(this.condition.mountings, this.pagination.mountings)
      const { current, total, size, records } = reponse.data
      this.dialog.mountings = records
      this.pagination.mountings.total = total
      this.pagination.mountings.current = current
      this.pagination.mountings.size = size
      this.loadingObj.mountings = false
    },
    async getFlotOutputsam(type = '') {
      if (type === 'refresh') {
        this.pagination.flotsam.current = 1
      }
      this.loadingObj.flotsam = true
      const reponse = await getFlotsamApi(this.condition.flotsam, this.pagination.flotsam)
      const { current, total, size, records } = reponse.data
      this.dialog.flotsam = records
      this.pagination.flotsam.total = total
      this.pagination.flotsam.current = current
      this.pagination.flotsam.size = size
      this.loadingObj.flotsam = false
    },
    // 配件
    addMountingsLine() {
      this.showObj.mountings = true
      this.getMountings()
    },
    delectOutsourceLineModels() {
      this.form.crmOutsourceProcessingLineModels = []
    },
    delectOutsourceOutputModels() {
      this.form.crmoutsourceprocessingoutputmodels = []
    },
    delectOutsourceInputModels() {
      this.form.crmoutsourceprocessinginputmodels = []
    },
    async getMountings(type = '') {
      if (type === 'refresh') {
        this.pagination.mountings.current = 1
      }
      this.loadingObj.mountings = true
      const reponse = await getMountingsApi(this.condition.mountings, this.pagination.mountings)
      const { current, total, size, records } = reponse.data
      this.dialog.mountings = records
      this.pagination.mountings.total = total
      this.pagination.mountings.current = current
      this.pagination.mountings.size = size
      this.loadingObj.mountings = false
    },
    handleMountingsDelete(index) {
      this.form.crmOutsourceProcessingLineModels.splice(index, 1)
    },
    handleMountingsOutputDelete(index) {
      this.form.crmoutsourceprocessingoutputmodels.splice(index, 1)
    },
    handleMountingsInputDelete(index) {
      this.form.crmoutsourceprocessinginputmodels.splice(index, 1)
    },
    handleMountingsChange(val) {
      this.selection.mountings = val
    },
    mountingsConfirm() {
      if (this.showObj.mountingsInput) {
        // 实验室投入
        const arr = JSON.parse(JSON.stringify(this.form.crmoutsourceprocessinginputmodels))
        if (arr !== null && arr.length > 0) {
          this.form.crmoutsourceprocessinginputmodels = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode', 'batch')
        } else {
          this.form.crmoutsourceprocessinginputmodels = this.selection.mountings
        }
        for (const item of this.form.crmoutsourceprocessinginputmodels) {
          delete item.createTime
          delete item.createUser
          delete item.updateTime
          delete item.updateUser
        }
      } else {
        // 订单明细
        debugger
        const arr = JSON.parse(JSON.stringify(this.form.crmOutsourceProcessingLineModels))
        if (arr !== null && arr.length > 0) {
          this.form.crmOutsourceProcessingLineModels = mergeObjectArrayWithoutDuplicates(arr, this.selection.mountings, 'productCode', 'batch')
        } else {
          this.form.crmOutsourceProcessingLineModels = this.selection.mountings
        }
        for (const item of this.form.crmOutsourceProcessingLineModels) {
          item.productType = 1
          delete item.createTime
          delete item.createUser
          delete item.updateTime
          delete item.updateUser
        }
      }
      this.showObj.mountings = false
    },
    // 导入
    getOutsourceProcessingLine(e) {
      console.log(e, 111223112)
      if (e.data.length <= 0) {
        this.$message.warning('数据导入失败，请检查数据源')
      } else {
        this.$message.success('数据导入成功')
        this.form.crmOutsourceProcessingLineModels = mergeObjectArrayWithoutDuplicates(this.form.crmOutsourceProcessingLineModels, e.data, 'productCode', 'batch')
      }
    },
    // 实验室投入导入
    getOutsourceProcessingInput(e) {
      if (e.data.length <= 0) {
        this.$message.warning('数据导入失败，请检查数据源')
      } else {
        this.$message.success('数据导入成功')
        this.form.crmoutsourceprocessinginputmodels = mergeObjectArrayWithoutDuplicates(this.form.crmoutsourceprocessinginputmodels, e.data, 'productCode', 'batch')
      }
    },
    // 下载模版
    handleOutsourceProcessingDownload() {
      downloadOutsourceProcessingTemplate().then((response) => {
        downloadFile(response)
      })
    },
    handleOutsourceProcessingInputDownload() {
      downloadOutsourceProcessingInputTemplate().then((response) => {
        downloadFile(response)
      })
    },
    handleOutsourceProcessingOutputDownload() {
      downloadOutsourceProcessingOutputTemplate().then((response) => {
        downloadFile(response)
      })
    },
    mountingsClose() {
      this.showObj.mountings = false
    },
    // 废料
    addFlotsamLine() {
      if (this.form.crmOutsourceProcessingLineModels.length > 0) {
        this.$message.warning('委外废料只能有一个明细行')
        return
      }
      this.showObj.flotsam = true
      this.getFlotsam()
    },
    async getFlotsam(type = '') {
      if (type === 'refresh') {
        this.pagination.flotsam.current = 1
      }
      this.loadingObj.flotsam = true
      const reponse = await getFlotsamApi(this.condition.flotsam, this.pagination.flotsam)
      const { current, total, size, records } = reponse.data
      this.dialog.flotsam = records
      this.pagination.flotsam.total = total
      this.pagination.flotsam.current = current
      this.pagination.flotsam.size = size
      this.loadingObj.flotsam = false
    },
    handleFlotsamChange(val) {
      this.selection.flotsam = val
    },
    flotsamConfirm() {
      if (this.showObj.flotsamOutput) {
        // 实验室产出
        const arr = JSON.parse(JSON.stringify(this.form.crmoutsourceprocessingoutputmodels))
        if (arr !== null && arr.length > 0) {
          this.form.crmoutsourceprocessingoutputmodels = mergeObjectArrayWithoutDuplicates(arr, this.selection.flotsam, 'productCode', '')
        } else {
          this.form.crmoutsourceprocessingoutputmodels = this.selection.flotsam
        }
        for (const item of this.form.crmoutsourceprocessingoutputmodels) {
          delete item.createTime
          delete item.createUser
          delete item.updateTime
          delete item.updateUser
        }
      } else {
        if (this.selection.flotsam.length > 1) {
          this.$message.warning('委外废料只能有一个明细行！')
          return
        }
        const arr = JSON.parse(JSON.stringify(this.form.crmOutsourceProcessingLineModels))
        if (arr !== null && arr.length > 0) {
          this.form.crmOutsourceProcessingLineModels = mergeObjectArrayWithoutDuplicates(arr, this.selection.flotsam, 'productCode', 'batch')
        } else {
          this.form.crmOutsourceProcessingLineModels = this.selection.flotsam
        }
        for (const item of this.form.crmOutsourceProcessingLineModels) {
          item.productType = 2
          delete item.createTime
          delete item.createUser
          delete item.updateTime
          delete item.updateUser
        }
      }
      this.showObj.flotsam = false
    },
    flotsamClose() {
      this.showObj.flotsam = false
    },
    // 判断有订单明细就给基础选项上锁
    judegIsDisabled() {
      if (this.form.crmOutsourceProcessingLineModels.length > 0) {
        this.isDisabled = true
      }
      if (this.form.crmOutsourceProcessingLineModels.length <= 0) {
        this.isDisabled = false
      }
    },
    // 录入加工成品
    addFinishedProduct() {
      this.showObj.finished = true
      this.getFinished()
    },
    async getFinished() {
      this.loadingObj.finished = true
      const reponse = await getFinished(this.form.id, this.pagination.finished)
      const { current, total, size, records } = reponse.data
      this.dialog.finished = records
      this.pagination.finished.total = total
      this.pagination.finished.current = current
      this.pagination.finished.size = size
      this.loadingObj.finished = false
    },
    async finishedConfirm() {
      if (this.dialog.finished.length <= 0) {
        this.$message.warning('加工成品明细行不能为空')
        return
      }
      let arr = []
      for (const item of this.dialog.finished) {
        if (!item.weight) {
          this.$message.warning('重量（KG）不能为空')
          arr = []
          return
        }
        arr.push({
          id: item.id || null,
          outsourceProcessingId: this.form.id,
          productCode: item.productCode,
          productName: item.productName,
          weight: item.weight,
          unit: item.unit

        })
      }

      const { message, data } = await saveOrUpdateFinished({ params: arr })
      this.$message({
        type: 'success',
        message: message
      })
      this.getFinished()
      this.finishedClose()
      console.log(this.dialog.finished)
    },
    finishedClose() {
      this.showObj.finished = false
    },
    // 加工成品废料明细
    addOutsourceFlotsamLine() {
      this.showObj.outsourceFlotsam = true
      this.getOutsourceFlotsam()
    },
    async getOutsourceFlotsam(type = '') {
      if (type === 'refresh') {
        this.pagination.outsourceFlotsam.current = 1
      }
      this.loadingObj.outsourceFlotsam = true
      const reponse = await getFlotsamApi(this.condition.outsourceFlotsam, this.pagination.outsourceFlotsam)
      const { current, total, size, records } = reponse.data
      this.dialog.outsourceFlotsam = records
      this.pagination.outsourceFlotsam.total = total
      this.pagination.outsourceFlotsam.current = current
      this.pagination.outsourceFlotsam.size = size
      this.loadingObj.outsourceFlotsam = false
    },
    handleOutsourceFlotsamChange(val) {
      this.selection.outsourceFlotsam = val
      for (const item of this.selection.outsourceFlotsam) {
        if (item.id) {
          delete item.id
        }
      }
    },
    outsourceFlotsamConfirm() {
      const arr = JSON.parse(JSON.stringify(this.dialog.finished))
      if (arr !== null && arr.length > 0) {
        this.dialog.finished = mergeObjectArrayWithoutDuplicates(arr, this.selection.outsourceFlotsam, 'productCode', 'batch')
      } else {
        this.dialog.finished = this.selection.outsourceFlotsam
      }
      // for (const item of this.form.crmOutsourceProcessingLineModels) {
      //   item.productType = 2
      // }
      this.showObj.outsourceFlotsam = false
    },
    handleFinishedDelete(id) {
      this.$confirm('请确认是否删除此数据', '提示', { type: 'warning' }).then(
        () => {
          console.log(id)
          deleteByIdFinished(id).then((response) => {
            this.$message.success('删除成功')
            this.getFinished()
          })
        }
      )
    },
    outsourceFlotsamClose() {
      this.showObj.outsourceFlotsam = false
    },
    // 录入采购订单
    async expenseConfirm() {
      // this.isExpense = true
      this.loading = true
      try {
        const { message, data } = await saveOrUpdateExpense({ id: this.form.id, processAmount: Number(this.form.processAmount) || 0, platinumTotal: Number(this.form.platinumTotal) || 0, palladiumTotal: Number(this.form.palladiumTotal) || 0, rhodiumTotal: Number(this.form.rhodiumTotal) || 0 })
        this.$message({
          type: 'success',
          message: message
        })
        this.editId = data || this.form.id
        this.getData()
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    async addPurchase() {
      const res = await getPurchase(this.form.id)
      console.log(this.$options.data().purchaseRow)
      if (res.data) {
        Object.assign(this.purchaseRow, res.data)
      } else {
        this.purchaseRow = this.$options.data().purchaseRow
        this.purchaseRow.factoryId = this.factoryOptions[0].value
      }
      console.log(this.purchaseRow)
      // this.purchaseRow = res.data || this.$options.data().purchaseRow

      this.showObj.purchase = true

      console.log(res)
    },
    purchaseConfirm() {
      this.$refs['purchaseForm'].validate(async (valid, obj) => {
        if (valid) {
          // this.form.mountingsList[this.purchaseIndex].crmPurchaseOrderModel
          const data = JSON.parse(JSON.stringify(this.purchaseRow))
          data.outsourceProcessingFormId = this.form.id
          const res = await saveOrUpdatePurchase(data)
          this.$message({
            type: 'success',
            message: res.message
          })
          this.purchaseClose()
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    purchaseClose() {
      // this.purchaseIndex = null
      this.purchaseRow = {}
      this.showObj.purchase = false
    },
    // 存储地点
    selectWarehouse() {
      this.showObj.warehouse = true
      this.getWarehouseDialog()
    },
    async getWarehouseDialog(type = '') {
      if (type === 'refresh') {
        this.pagination.warehouse.current = 1
      }
      this.loadingObj.warehouse = true
      const reponse = await getCompanyInfoFactoryListPage(this.condition.warehouse, this.pagination.warehouse)
      const { current, total, size, records } = reponse.data
      this.dialog.warehouse = records
      this.pagination.warehouse.total = total
      this.pagination.warehouse.current = current
      this.pagination.warehouse.size = size
      this.loadingObj.warehouse = false
    },
    handleWarehouseSelectionChange(val) {
      this.selection.warehouse = val
    },
    warehouseConfirm() {
      if (this.selection.warehouse.length > 1) {
        this.$message.warning('只能选择一个存储地点！')
      } else {
        this.showObj.warehouse = false
        this.purchaseRow.warehouseCode = this.selection.warehouse[0].warehouseNumber
        this.purchaseRow.warehouseId = this.selection.warehouse[0].id
      }
    },
    warehouseClose() {
      this.showObj.warehouse = false
    },
    async getData() {
      if (!this.editId) return
      this.loading = true
      try {
        const response = await get(this.editId)
        const { data } = response
        this.form = data
        this.form.orderType = this.form.orderType.toString()
        this.form.flowPathTemplateId = this.form.flowPathTemplateId === 0 ? null : this.form.flowPathTemplateId
        this.isExpense = this.form.processAmount && this.form.processAmount > 0
        this.flowRejectTo(null, null)
        this.loading = false
      } catch (error) {
        this.loading = false
      }
    },
    handleClose() {
      Object.assign(this.$data, this.$options.data.call(this))
      this.$router.push({ query: {} })
      this.$emit('close')
    },
    async submitForm(formName, isClose = true, cb) {
      // ---- 需要手工填写此代码 -----
      this.$refs[formName].validate(async (valid, obj) => {
        console.log(valid)
        if (valid) {
          // ---- 需要手工填写此代码 -----
          try {
            this.loading = true
            const formData = JSON.parse(JSON.stringify(this.form))
            console.log(formData)
            if (formData.crmOutsourceProcessingLineModels.length <= 0) {
              this.$message.warning('订单明细不能为空')
              this.loading = false
              return
            }
            const { message, data } = await saveOrUpdate(formData)
            this.$message({
              type: 'success',
              message: message
            })
            this.form.id = this.form.id || data
            this.editId = this.form.id || data
            await this.getData()
            this.loading = false
            if (cb) {
              await cb()
            }
            if (isClose) {
              this.handleClose()
            }
          } catch (error) {
            console.log(error)
            this.loading = false
          }
        } else {
          for (const key in obj) {
            this.$message({
              type: 'warning',
              message: obj[key][0].message
            })
            return false
          }
          return false
        }
      })
    },
    flowRefresh() {
      this.getData()
      this.handleClose()
    },
    flowLoad(e) {
      this.flowOptions = e
      this.$refs.flow.validatorForm.push(this.$refs.isProceeds)
    },

    // 流程提交
    async onComplete() {
      this.flowPathNodePersonModels.nodePerson[0].required = true
      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        // await this.getData();
        // 在执行提交
        await this.$refs.flow.onComplete()
        this.handleClose()
      })
    },
    // 保存并提交
    async saveAndSubmit() {
      this.flowPathNodePersonModels.nodePerson[0].required = true

      if (!this.form.flowPathTemplateId) {
        this.$message({
          type: 'warning',
          message: '请选择流程模板'
        })
        return
      }
      // 先执行保存
      await this.submitForm('form', false, async () => {
        await this.submit()
      })
    },
    // flowLoadPrice(e) {
    //   this.flowOptions = e
    //   this.$refs.priceFlow.validatorForm.push(this.$refs.isProceeds)
    // },
    flowRejectTo(isAssignee, nodeName) {
      console.log(isAssignee && nodeName)
      if (isAssignee && nodeName === '开始') {
        this.isRejectTo = false
      } else {
        if (this.form.status > 1) {
          this.isRejectTo = true
        } else {
          this.isRejectTo = false
        }
      }
    },
    async submit() {
      try {
        this.loading = true
        const response = await submit(this.form.id)
        this.form.flowId = response.data
        this.loading = false
        // this.handleClose()
        this.getData()
      } catch (error) {
        this.loading = false
      }
    }
  }
}
</script>
<style scoped>
.btn {
  color: #ffffff;
  background-color: #409eff;
  border-color: #409eff;
  padding: 7px 15px;
  font-size: 12px;
  border-radius: 3px;
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  /* background: #ffffff; */
  /* border: 1px solid #dcdfe6; */
  text-align: center;
  box-sizing: border-box;
  outline: none;
  margin: 0;
  -webkit-transition: 0.1s;
  transition: 0.1s;
  font-weight: 400;
  margin-right: 10px;
}
.btn:hover {
  background: #66b1ff;
  border-color: #66b1ff;
  color: #ffffff;
}
.link {
  color: #606266;
  font-weight: lighter;
}
.link:hover {
  color: rgb(64, 158, 255);
  font-weight: lighter;
}
.upload {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;
  align-items: center;
}
.upload >>> .el-upload-list__item:first-child {
  margin-top: 0;
}
.uploads {
  clear: both;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}
.el-upload {
  flex: 1;
}

.el-upload__tip {
  margin-top: 0;
  margin-left: 10px;
  flex: 1;
}
.el-col {
  min-height: 50px;
}
.selectNone {
  user-select: none;
}
</style>

